
import { Component, PropSync, Vue, Watch } from 'vue-property-decorator';
import ScreenCanvas from "@/components/stead/store/screens/ScreenCanvas.vue";
import { ScreenDocumentFlat, ScreenToyDocument } from "@/models/screen.model";
import { ToyDocument } from "@/models/tobject.model";
import { fetchToys } from "@/axios/repository/tobject.axios";

@Component({
  components: {ScreenCanvas}
})
export default class SbScreenToysPanel extends Vue {
  // Les props
  @PropSync('screen') private screenData!: ScreenDocumentFlat | null
  @PropSync('show') private isVisible!: boolean

  // Les propriétés
  private loading: boolean = false
  private toys: ToyDocument[] = []
  private hoveredToy: ScreenToyDocument | null = null
  private boxH: number = 0

  // Les propriétés calculées
  private get urlShot() {
    return this.screenData ? this.$store.getters['screen/shotUrl'](this.screenData.screenshot) : '';
  }

  // Les hooks
  public mounted() {
    // console.log('mounted ScreenToyDocument')
    this.$nextTick(() => this.listener())
    window.addEventListener('resize', this.listener)
  }

  public beforeDestroy() {
    // console.log('beforeDestroy ScreenToyDocument')
    window.removeEventListener('resize', this.listener)
  }

  // Les méthodes surveillées
  @Watch('screenData')
  private async loadScreen() {
    if (this.screenData) {
      this.loading = true
      const toys = await fetchToys(this.screenData._id)
      this.toys = toys.sort((a, b) => a.name.localeCompare(b.name))
      await this.$store.dispatch('screen/loadOneShot', this.screenData.screenshot)
      this.loading = false
    }
  }

  // Les méthodes d'instance
  private onSelectToy(toy: ScreenToyDocument) {
    // console.log('ScreenToysPanel - emit toy', toy)
    this.$emit('toy', toy);
    this.isVisible = false;
  }

  private listener() {
    const box = document.getElementById('scapin-content') as HTMLDivElement
    if (box) {
      // console.log(`scapin content h=${box.clientHeight}, w=${box.clientWidth}`)
      this.boxH = box.clientHeight * 0.75
    } else {
      this.boxH = 0
    }
    // console.log('listerner boxH=', this.boxH)
  }

  // Les méthodes statiques
}
